import type { Bio as BioType, SkillCategory, Experience, Education, Project } from '../types/data';

export const Bio: BioType = {
  name: "SIYAM UDDIN",
  roles: [
    "Software Engineer",
    "Fullstack Developer",
    "DevOps/Cloud Expert",
  ],
  description:
    "Full-Stack Software Engineer with 2+ years of experience delivering production-grade platforms using Java, Spring Boot, React, and Python. Proven track record building and shipping real products — from social fintech platforms to AI-powered tools and high-throughput flight booking systems. Deep expertise in microservices, REST APIs, cloud infrastructure (AWS, Docker), CI/CD, OAuth2/JWT security, and AI/ML integration. Currently a Software Engineer at Sellerket LTD and freelance developer for Asia Pacific Aviation.",
  github: "https://github.com/Siyamuddin",
  resumeKorean: "/resumes/siyam-uddin-resume-ko.pdf",
  resumeEnglish: "/resumes/siyam-uddin-resume-en.pdf",
  aibuddy:"https://lecture2-notebook-frontend.vercel.app/",
  linkedin: "https://www.linkedin.com/in/uddin-siyam-8953511ab/",
  twitter: "https://x.com/SiyamUddin12",
  insta: "https://www.instagram.com/siyam7_/",
  facebook: "https://www.facebook.com/siyam.mizi.9465/",
  youtube:"https://www.youtube.com/channel/UCEXfHCvKeFF4tpfMhYRDcdg",
};

export const skills: SkillCategory[] = [
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://www.svgrepo.com/show/452234/java.svg",
      },
      {
        name: "Spring Boot",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Spring_Boot.svg/1024px-Spring_Boot.svg.png?20230616230349",
      },
      {
        name: "Spring Security",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/spring/spring-original.svg",
      },
      {
        name: "FastAPI",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/fastapi/fastapi-original.svg",
      },
      {
        name: "AWS",
        image: "https://www.svgrepo.com/show/448266/aws.svg",
      },
      {
        name: "CI/CD",
        image: "https://raw.githubusercontent.com/jpb06/jpb06/master/icons/GithubActions-Dark.svg",
      },
      {
        name: "OAuth",
        image: "https://www.svgrepo.com/show/354135/oauth.svg",
      },
      {
        name: "gRPC",
        image: "https://www.svgrepo.com/show/354380/grpc.svg",
      },
      {
        name: "Apache Kafka",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEF0oWlFL6z8t1NuFupS7kQKoZoGvSzxVwCw&s",
      },
      
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MariaDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mariadb/mariadb-original-wordmark.svg",
      },
      {
        name: "Redis",
        image:
          "https://www.svgrepo.com/show/303460/redis-logo.svg",
      },
      {
        name: "ChromaDB",
        image: "https://avatars.githubusercontent.com/u/104965775?s=200&v=4",
      },
    ],
  },
  
  {
    title: "Tools",
    skills: [
      {
        name: "TypeScript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      },
      {
        name: "Linux",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg",
      },
      {
        name: "Llama",
        image:
          "https://www.svgrepo.com/show/191122/llama.svg",
      },
      {
        name: "Ollama",
        image: "https://ollama.com/public/ollama.png",
      },
      
      {
        name: "LangChain4j",
        image:
          "https://docs.langchain4j.dev/img/logo.svg",
      },
      {
        name: "OpenAI",
        image:
          "https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/openai.svg",
      },
      {
        name: "Whisper ASR",
        image:
          "https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/openai.svg",
      },
      {
        name: "Swagger",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Swagger-logo.png/640px-Swagger-logo.png",
      },

      {
        name: "Git",
        image:
          "https://www.svgrepo.com/show/452210/git.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Postman",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/postman/postman-original.svg",
      },
      {
        name: "Maven",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/maven/maven-original.svg",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Docker Compose",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Prometheus",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/prometheus/prometheus-original.svg",
      },
      {
        name: "Grafana",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/grafana/grafana-original.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Intellijidea",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/IntelliJ_IDEA_Icon.svg/1024px-IntelliJ_IDEA_Icon.svg.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },

    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/640px-Tailwind_CSS_Logo.svg.png",
      }
    ],
  },
];

export const experiences: Experience[] = [
  {
    id: 0,
    key: "sellerket",
    img: "/logoSellerket.png",
    role: "Software Engineer",
    company: "Sellerket LTD",
    date: "March 2025 - Present",
    desc: `Led end-to-end migration of a legacy platform to a modern full-stack architecture (React 19 + Spring Boot), preserving user experience with zero downtime.
Delivered multiple investor-facing MVPs rapidly — balancing speed, reliability, and polished UI under tight deadlines.
Designed and shipped GlobalSellerket, a brand-influencer e-commerce platform, and Setlone, a social networking + fintech platform — both live on AWS with CI/CD automation.
Architected secure backend systems with Spring Boot, JWT/OAuth2 RBAC, Redis caching, WebSocket, and GitHub Actions pipelines across multiple production services.`,
    skills: [
      "Docker",
      "AWS",
      "GitHub Actions",
      "CI/CD",
      "Java",
      "Spring Boot",
      "React 19",
      "REST APIs",
      "Microservices",
      "MySQL",
      "Redis",
      "Spring Security",
      "OAuth2",
      "JWT",
      "WebSocket",
    ],
  },
  {
    id: 1,
    key: "asia_pacific_aviation",
    img: "/AsiaPasificAviation.jpg",
    role: "Software Developer (Freelance)",
    company: "Asia Pacific Aviation",
    date: "Present",
    desc: `Architected and built AirSeoul, a full-stack flight booking platform supporting 50,000+ API requests/hour with Redis caching, rate limiting, and atomic seat booking (REPEATABLE_READ isolation).
Implemented a comprehensive security layer: JWT with refresh token rotation, OAuth2 (Google), RBAC, CSRF/XSS/HSTS headers, account lockout, per-IP rate limiting, and full audit logging.
Integrated TossPay payment gateway with idempotency checks and webhook validation; built admin dashboard with analytics, flight management, and dynamic app settings.
Set up full observability stack (Prometheus, Grafana, Loki + Promtail) and containerized the entire application with Docker Compose for dev and production environments.`,
    skills: [
      "Docker",
      "AWS",
      "EC2",
      "Java",
      "Spring Boot",
      "TypeScript",
      "React",
      "MySQL",
      "Redis",
      "Spring Security",
      "OAuth2 (Google)",
      "JWT",
      "Rate limiting",
      "TossPay",
      "Prometheus",
      "Grafana",
      "Loki",
      "Docker Compose",
      "CI/CD",
    ],
  },
  {
    id: 2,
    key: "noormartt",
    img: "https://www.wowabouts.com/z-media/2018/10/Seoul%20Central%20Mosque.jpg",
    role: "Backend Engineer Intern",
    company: "NoorMartt",
    date: "January 2024 - Present",
    desc: "Working on designeing and developing E-commerce system.",
    skills: [
      "Java",
      "Spring Boot",
      "Spring Security",
      "MySql",
      "Docker",
      "EC2",
      "Swagger",
    ],
  },
];

export const education: Education[] = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/thumb/e/ee/Sejong_University_logo.svg/1200px-Sejong_University_logo.svg.png",
    school: "Sejong University, Seoul",
    date: "Sept 2022 - Expected 2026",
    grade: "Scholarship (Outstanding Students), 2022",
    desc: `B.S. in Computer Engineering.\n\nRelevant Courses: OOP, Data Structures, Operating Systems, DBMS, Computer Networks, AI & Big Data, Software Engineering, Web Programming.`,
    degree: "B.S. in Computer Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjBfGf0MbZfleIBusJq5zG74upu0oX7OPSTA&s",
    school: "Faridganj Bangabandhu GOVT. College, Chandpur",
    date: "Aug 2019 - Jan 2021",
    grade: "93.4%",
    desc: "I completed my class 12 high school education at Faridganj Bangabandhu GOVT. College, Chandpur, where I studied Science with Higher Mathematics.",
    degree: "HSC, Science with Higher Mathematics",
  },
  {
    id: 2,
    img: "https://yt3.googleusercontent.com/ytc/AIdro_lChp712P-MIwyNujk7jZEh7vs42Au9CGh6_Ba5uciJ=s900-c-k-c0x00ffffff-no-rj",
    school: "Chandra Imam Ali High School and College, Chandpur",
    date: "Apr 2014 - Apr 2019",
    grade: "84.4%",
    desc: "I completed my class 10 education at Chandra Imam Ali High School and College, Chandpur, where I studied Science with CHigher Mathematics.",
    degree: "SSC, Science with Higher Mathematics",
  },
];

export const projects: Project[] = [
  {
    id: 7,
    key: "setlone",
    title: "Setlone",
    date: "MAR 2025 - Present",
    description:
      "Built a full-stack social networking + fintech platform using React 19 and Spring Boot. Secured with JWT/OAuth2 and deployed on AWS with Docker Compose and CI/CD automation.",
    image: "/SELTONE_LOGO_PNG_WHITE.png",
    tags: [
      "React 19",
      "TypeScript",
      "Spring Boot",
      "Java 17",
      "MySQL",
      "Redis",
      "Docker Compose",
      "AWS",
      "JWT",
      "OAuth2",
      "CI/CD",
    ],
    category: "web app",
  },
  {
    id: 8,
    key: "globalsellerket",
    title: "GlobalSellerket",
    date: "MAR 2025 - Present",
    description:
      "Developed a campaign-driven e-commerce platform connecting brands and influencers using React (TypeScript) and Spring Boot (Java 17). Implemented JWT/OAuth2 RBAC and deployed on AWS with Docker Compose and CI/CD automation.",
    image: "/logoSellerket.png",
    tags: [
      "React",
      "TypeScript",
      "Spring Boot",
      "Java 17",
      "MySQL",
      "Docker Compose",
      "AWS",
      "JWT",
      "OAuth2",
      "RBAC",
      "CI/CD",
    ],
    category: "web app",
  }
  ,
  {
    id: 6,
    key: "airseoul",
    title: "AirSeoul",
    date: "DEC 2025 - Present",
    description:
      "Architected a full-stack flight booking platform handling 50,000+ API requests/hour with Redis-based rate limiting and caching. Built secure auth (JWT + refresh rotation, OAuth2 Google, RBAC, device tracking), atomic seat booking (REPEATABLE_READ), payments via TossPay with webhook validation, and full observability (Prometheus/Grafana/Loki).",
    image: "/AsiaPasificAviation.jpg",
    tags: [
      "Java",
      "Spring Boot",
      "React.js",
      "TypeScript",
      "MySQL",
      "Redis",
      "Docker Compose",
      "AWS",
      "JWT",
      "OAuth2",
      "Prometheus",
      "Grafana",
      "Loki",
      "Flyway",
    ],
    category: "web app",
  },
  {
    id: 0,
    key: "lecture2notebook",
    title: "Lecture2Notebook",
    date: "MAR 2025 - JUNE 2025",
    description:"This an web aplication for Sejong University students where they use this to convert any type of Python lectures video into notebook file with code. ",
    image:"/Lecture2Notebook.png",
    tags: ["Python, FastAPI,Lama3.2,wispher,Javascript", "React.js", "HTML", "CSS"],
    category: "web app",
    github: "https://github.com/Siyamuddin/Lecture2Notebook",
    webapp: "https://lecture2-notebook-frontend.vercel.app/",
  },
  {
    id: 1,
    key: "aibuddy",
    title: "AiBuddy",
    date: "SEPT 2024 - present",
    description:
    "AI-powered student support application using LangChain4j, enhancing response relevance by 30%, benefiting all my campus students. Reduced API response time by 25% through Redis caching optimization. Employed advanced natural language processing techniques, including LangChain4j, Llamas3.2, and embedding model, to implement Retrieval Augmented Generation (RAG) operations with advance Prompt Engineering. This approach significantly improved the quality and relevance of AI-generated responses. Students can easily upload lecture materials and benefit from personalized AI assistance, enhancing their overall learning experience.(Currently working on it)",
    image:
    "/aibuddy.png",
    tags: [
      "Docker",
      "AWS",
      "EC2",
      "Llama3",
      "LangChain4j",
      "CI/CD",
      "Java",
      "Spring Boot",
      "MySql",
      "Redis",
      "Spring Security",
    ],
    category: "web app",
    github: "https://github.com/Siyamuddin/RAG_and_Langchain4j",
    webapp: "https://aibuddy.digital",
  },
  {
    id: 2,
    key: "noormart",
    title: "NoorMart",
    date: "DEC 2023 - FEB 2024",
    description:
    "This platform serves as a user-friendly semi ecommerce duty- free shop, allowing administrators to effortlessly manage products, payments, and sales history."+
    "Admins can seamlessly add, update, or remove products while tracking payments and accessing monthly and yearly sales data. Additionally, they have the capability to notify customers about new offers and deals via email."+
    "I have secured this using Spring Security and JWT authentication.",
    image:
    "/masjidNoor.jpg",
    tags: ["Spring Boot", "Java", "MySql", "Redis", "Spring Security","Docker"],
    category: "web app",
    github: "https://github.com/rishavchanda/Podstream",
  },
  {
    id: 3,
    key: "chatbees",
    title: "ChatBees",
    date: "OCT 2023 - DEC 2023",
    description:
"A chatting application for multiple users. It allows user to enter in a chatroom just simply providing his/her name and start chatting, it works like walki-talki. It was a class project for the class Problem Solving with Java by prof. Geyanendra Prasad Joshi.",
  image:
  "/ChatbeesLogo.jpg",
    tags: [
      "Java",
      "Spring Boot",
      "WebSocket",
    ],
    category: "web app",
    github: "https://github.com/Siyamuddin/ChatBees",
  },
  {
    id: 4,
    key: "smart_task_manager",
    title: "Smart Task-Manager",
    date: "JAN 2023 - MAR 2023",
    description:
"This smart task manager enables users to create accounts securely authenticated by JWT. Users can effortlessly create tasks, receiving confirmation emails upon task creation. Additionally, the system automatically sends reminder emails if tasks remain incomplete, ensuring timely completion. This streamlined approach enhances user productivity and accountability while maintaining security and convenience.",
    image:
"/stm.png",
    tags: ["Java", "Spring Boot", "Spring Security", "JWT", "MySql", "Redis"],
    category: "web app",
    github: "https://github.com/Siyamuddin/smart-task-manager",
  },
  {
    id: 5,
    key: "portfolio",
    title: "Portfolio",
    date: "FEB 2024 - MAR 2024",
    description:" This my portfolio website, you find all my lates skills and projects here. It is user friendly and responsive. It also has dynamic featuers like email response and etc. ",
    image:"/portfolio.png",
    tags: ["Javascript", "React.js", "HTML", "CSS"],
    category: "web app",
    github: "https://github.com/Siyamuddin/MyPortfolio",
    webapp: "https://uddin.netlify.app/",
  }
];
